<template>
  <div id="addExchangePurchase">
    <el-page-header @back="goBack" content="新增换货采购"> </el-page-header>
    <el-row class="padding-bottom-row">
      <el-col :span="leftSpan">
        <div class="content-label">供应商名称</div>
        <div class="content-label">退货物流公司</div>
        <div class="content-label">退货物流单号</div>
        <div class="content-label">采购编号</div>
      </el-col>
      <el-col :span="rightSpan">
        <div class="content-span">{{ exchangeRefundInfo.supplierName }}</div>
        <div class="content-span">
          {{ exchangeRefundInfo.returnLogisticsOrgTypeLabel }}
        </div>
        <div class="content-span">
          {{ exchangeRefundInfo.returnLogisticsOrderNo }}
        </div>
        <div class="content-span">
          <el-button
            type="text"
            v-for="(item, index) in exchangeRefundInfo.returnInboundRecordIdSet"
            :key="item"
            @click="goStoreIn(item)"
          >
            {{
              item +
              (index == exchangeRefundInfo.returnInboundRecordIdSet.length - 1
                ? ""
                : ",")
            }}
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="padding-bottom-row">
      <el-col :span="leftSpan">
        <div class="content-label">换货物流公司</div>
      </el-col>
      <el-col :span="rightSpan">
        <div class="content-span">
          <span>{{ params.logisticsOrgName }}</span>
          <el-button type="text" @click="dialogFormVisible = true"
            >请选择</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="padding-bottom-row">
      <el-col :span="leftSpan">
        <div class="content-label">换货物流单号</div>
      </el-col>
      <el-col :span="rightSpan">
        <el-input
          v-model="params.exchangeLogisticsOrderNo"
          placeholder="请输入换货物流单号"
        ></el-input>
      </el-col>
    </el-row>
    <el-row class="padding-bottom-row">
      <el-col :span="leftSpan">
        <div class="content-label">采购状态</div>
      </el-col>
      <el-col :span="rightSpan">
        <el-select v-model="params.storeInStatus">
          <el-option
            v-for="item in storeInStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row class="padding-bottom-row">
      <el-col :span="leftSpan">
        <div class="content-label">换货材料列表</div>
      </el-col>
      <el-col :span="rightSpan">
        <el-row class="padding-bottom-row">
          <el-table :data="tableData" border>
            <el-table-column
              prop="rawMaterialId"
              label="材料Id"
            ></el-table-column>
            <el-table-column
              prop="totalReturnQuantity"
              label="退货数量"
            ></el-table-column>
            <el-table-column
              prop="totalReturnAmount"
              label="退货金额"
            ></el-table-column>
            <el-table-column
              prop="unitPrice"
              label="平均单价"
            ></el-table-column>
            <el-table-column label="可换货数量">
              <template v-slot="scope">
                {{
                  parseInt(scope.row.totalReturnQuantity) -
                  parseInt(scope.row.totalExchangeQuantity)
                }}
              </template>
            </el-table-column>
            <el-table-column label="换货数量">
              <template v-slot="scope">
                <el-input v-model="scope.row.quantity"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="换货金额">
              <template v-slot="scope">
                {{
                  (scope.row.quantity ? scope.row.quantity : 0) *
                  parseFloat(scope.row.unitPrice)
                }}
              </template>
            </el-table-column>
            <el-table-column label="备注">
              <template v-slot="scope">
                <el-input v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row class="padding-bottom-row">
          <el-button type="primary" size="mini" @click="goBack">取消</el-button>
          <el-button type="primary" size="mini" @click="batchPurchase"
            >确定</el-button
          >
        </el-row>
      </el-col>
    </el-row>

    <el-dialog
      class="logistics-list-dialog"
      title="收货地址"
      :visible.sync="dialogFormVisible"
      :close="cancelDialog"
      width="30%"
    >
      <el-form>
        <el-form-item>
          <el-radio-group v-model="logisticsOrgCode">
            <el-radio
              v-for="item in logisticsList"
              :key="item.code"
              :label="item.code"
              @change="logisticsRadioChange(item)"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="confirmDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { returnModules } from "@r";
import {createNamespacedHelpers} from 'vuex';
const { 
  mapGetters: returnMapGetters
} = createNamespacedHelpers('returnModel');
export default {
  created() {
    this.exchangeRefundInfo = {};
  },
  activated() {
    const {id, operateType} = this.$route.query;
    this.exchangeRefundInfo = {...this.getReturnInfoById(id), operateType};
    this.queryReturnDetail();
    this.$nextTick(() => {
      this.$forceUpdate();
    });
  },
  data() {
    return {
      leftSpan: 2,
      rightSpan: 22,
      params: {
        storeInStatus: 1,
        logisticsOrgType: "",
        logisticsOrgName: "未选择",
        exchangeLogisticsOrderNo: "",
      },
      dialogFormVisible: false,
      tableData: [],
      storeInStatusOptions: [
        {
          label: "已下单,卖家未发货",
          value: 1,
        },
      ],
      logisticsOrgInfo: {},
      logisticsOrgCode: "",
      logisticsList: [
        { code: 0, label: "虚拟物流公司"},
        { code: 1, label: "顺丰快递" },
        { code: 2, label: "圆通速递" },
        { code: 3, label: "中通快递" },
        { code: 4, label: "韵达快递" },
        { code: 5, label: "申通快递" },
        { code: 6, label: "邮政EMS" },
        { code: 7, label: "天天快递" },
        { code: 8, label: "优速快递" },
        { code: 9, label: "百世快递" },
        { code: 10, label: "百世快运" },
        { code: 11, label: "百腾物流" },
        { code: 12, label: "安能物流" },
        { code: 13, label: "邮政快递包裹" },
        { code: 14, label: "壹米滴答" },
        { code: 15, label: "德邦快递" },
        { code: 16, label: "顺心捷达" },
        { code: 17, label: "信丰物流" },
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goStoreIn(id) {
      location.href = "/client/storeIn?id=" + id;
    },
    logisticsRadioChange(item) {
      this.logisticsOrgInfo = item;
    },
    cancelDialog() {
      this.dialogFormVisible = false;
      this.logisticsOrgCode = this.params.logisticsOrgType;
    },
    confirmDialog() {
      this.dialogFormVisible = false;
      this.params.logisticsOrgType = this.logisticsOrgInfo.code;
      this.params.logisticsOrgName = this.logisticsOrgInfo.label;
    },
    queryReturnDetail() {
      returnModules
        .detail({
          returnLogisticsOrgType: this.exchangeRefundInfo
            .returnLogisticsOrgType,
          returnLogisticsOrderNo: this.exchangeRefundInfo
            .returnLogisticsOrderNo,
        })
        .then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "详情获取失败",
            });
            return;
          }
          console.log(res.params);
          if (
            res.params.returnLogisticsOrderNo !=
            this.exchangeRefundInfo.returnLogisticsOrderNo
          ) {
            return;
          }
          this.tableData = res.mdata.inboundReturnDTOList;
        });
    },
    batchPurchase() {
      returnModules.batchPurchase(this.getExchangeListParams()).then(() => {
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.goBack();
      });
    },
    getExchangeListParams() {
      if (this.params.logisticsOrgType === "") {
        this.$message({
          type: "error",
          message: "请选择换货物流公司",
        });
        return null;
      }
      if (this.params.exchangeLogisticsOrderNo === "") {
        this.$message({
          type: "error",
          message: "请输入换货物流单号",
        });
        return null;
      }
      const concatObject = {
          freight: 0,
          logisticsOrgType: this.params.logisticsOrgType,
          logisticsOrderNo: this.params.exchangeLogisticsOrderNo,
          purchaseStatus: this.params.storeInStatus,
           relationReturnLogisticsOrgType: this.exchangeRefundInfo
            .returnLogisticsOrgType,
          relationReturnLogisticsOrderNo: this.exchangeRefundInfo
            .returnLogisticsOrderNo,
          supplierId: this.exchangeRefundInfo.supplierId
        }
      const returnList = this.tableData.map((item) => {
        return {
          quantity: item.quantity,
          remark: item.remark,
          rawMaterialId: item.rawMaterialId,
          unitPrice: item.unitPrice,
          ...concatObject
        }
      });
      return JSON.stringify(returnList);
    },
  },
  computed: {
    ...returnMapGetters(['getReturnInfoById'])
  }
};
</script>

<style lang="scss">
.logistics-list-dialog {
  .el-radio {
    margin-bottom: 20px;
    width: 145px;
  }
}
.padding-bottom-row {
  padding-bottom: 10px;
}
.el-table td {
  padding: 0;
}
.content-label {
  padding: 5px 0;
  line-height: 20px;
  text-align: right;
}
.content-label::after {
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}
.content-span {
  padding: 5px 0;
  line-height: 20px;
}
.el-button.el-button--text {
  padding: 0;
  margin: 0 10px 0 0;
}
.el-table__expanded-cell[class*="cell"] {
  padding: 0px 0px 0px 47px;
}
</style>
